// extracted by mini-css-extract-plugin
export var callCard = "_nl-0";
export var callMessageButton = "_nl-1";
export var helpIcon = "_nl-3";
export var helpIconContainer = "_nl-4";
export var verticalDivider = "_nl-2";